module.exports = __webpack_public_path__ + "static/fabric-table-search-01bfdf09325266a50a5d2eaf3a2ae2d8.png";